/* global process */
let base = window._env_.VUE_APP_ADMIN_HOST
export const getTaskNoticeTable = params => {
  return axios.post(`${base}/task-notice/query`, params)
}
export const getTaskNoticeDetail = params => {
  return axios.get(`${base}/task-notice/get_${params.id}`, {params})
}
export const exportTaskNoticeData = params => {
  return axios.get(`${base}/exportTaskNoticeData/${params.id}`, {params})
}
export const createTaskNoticeData = params => {
  return axios.post(`${base}/task-notice/create`, params)
}
export const updateTaskNoticeData = params => {
  return axios.post(`${base}/task-notice/edit_${params.id}`, params)
}
export const setOnlineTaskNoticeData = params => {
  return axios.post(`${base}/task-notice/set_oneline_${params.id}`, params)
}
export const deleteTaskNoticeData = params => {
  return axios.post(`${base}/deleteTaskNoticeData/${params.id}`, params)
}
export const uploadTaskNoticeFile = (params, config) => {
  return axios.post(`${base}/task-notice/uploadfile`, params, config)
}



// WEBPACK FOOTER //
// ./src/views/task-notice/task-notice.api.js